import React from 'react';
interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: 'primary' | 'secondary' | 'outline';
  fullWidth?: boolean;
}
export function Button({
  children,
  variant = 'primary',
  fullWidth = false,
  className = '',
  ...props
}: ButtonProps) {
  const baseStyles = 'inline-flex items-center justify-center px-6 py-3.5 text-sm font-medium transition-all duration-300 rounded-full focus:outline-none focus:ring-2 focus:ring-luxury-gold focus:ring-offset-2 focus:ring-offset-luxury-cream disabled:opacity-50 disabled:cursor-not-allowed';
  const variants = {
    primary: 'bg-luxury-gold text-luxury-charcoal hover:bg-[#cbb882] shadow-[0_0_20px_rgba(185,164,106,0.15)] hover:shadow-[0_0_25px_rgba(185,164,106,0.3)]',
    secondary: 'bg-luxury-charcoal text-luxury-white hover:bg-luxury-charcoal/90',
    outline: 'bg-transparent border border-luxury-gold/30 text-luxury-gold hover:bg-luxury-gold/5'
  };
  return <button className={`${baseStyles} ${variants[variant]} ${fullWidth ? 'w-full' : ''} ${className}`} {...props} data-id="element-171">
      {children}
    </button>;
}